module.exports = __webpack_public_path__ + "img/RecentNew.34928941.png";